window.theme = window.theme || {};

theme.inlineNavigationCheck = function () {
  var pageHeader = document.querySelector('.pageheader');
  if (!pageHeader) return;

  var inlineNavContainer = pageHeader.querySelector('.logo-area__left__inner');
  if (!inlineNavContainer) return;

  var inlineNav = inlineNavContainer.querySelector('.navigation--left');
  if (!inlineNav || getComputedStyle(inlineNav).display === 'none') return;

  var inlineMenuCentered = document.querySelector('.pageheader--layout-inline-menu-center');
  var logoContainer = document.querySelector('.logo-area__middle__inner');

  if (inlineMenuCentered && logoContainer) {
    var rightWidth = document.querySelector('.logo-area__right__inner').clientWidth;
    var middleWidth = logoContainer.clientWidth;
    var logoArea = document.querySelector('.logo-area');
    var computedLogoAreaStyle = getComputedStyle(logoArea);
    var logoAreaInnerWidth = logoArea.clientWidth - Math.ceil(parseFloat(computedLogoAreaStyle.paddingLeft)) - Math.ceil(parseFloat(computedLogoAreaStyle.paddingRight));
    var availableNavWidth = logoAreaInnerWidth - Math.max(rightWidth, middleWidth) * 2 - 40;
    inlineNavContainer.style.maxWidth = availableNavWidth + 'px';
  }

  var firstInlineNavLink = inlineNav.querySelector('.navigation__item:first-child');
  var lastInlineNavLink = inlineNav.querySelector('.navigation__item:last-child');
  if (!lastInlineNavLink || !logoContainer) return;

  function measureInlineNavWidth() {
    if (document.querySelector('html[dir=rtl]')) {
      return firstInlineNavLink.offsetLeft - lastInlineNavLink.offsetLeft + firstInlineNavLink.offsetWidth;
    }
    return lastInlineNavLink.offsetLeft - firstInlineNavLink.offsetLeft + lastInlineNavLink.offsetWidth;
  }

  pageHeader.classList.add('pageheader--layout-inline-permitted');
  pageHeader.style.removeProperty('--nav-l1-inline-size');
  pageHeader.style.removeProperty('--nav-l1-inline-pad');

  var available = inlineNavContainer.offsetWidth;
  var inlineNavWidth = measureInlineNavWidth();
  if (inlineNavWidth > available) {
    pageHeader.style.setProperty('--nav-l1-inline-pad', '10px');
    inlineNavWidth = measureInlineNavWidth();
  }
  if (inlineNavWidth > available) {
    pageHeader.style.setProperty('--nav-l1-inline-pad', '6px');
    inlineNavWidth = measureInlineNavWidth();
  }
  if (inlineNavWidth > available) {
    var baseSize = parseFloat(getComputedStyle(lastInlineNavLink.querySelector('.navigation__link')).fontSize) || 14;
    // ponytail: 11px floor. Longer L1 labels need fewer items, not smaller type.
    pageHeader.style.setProperty('--nav-l1-inline-size', Math.max(11, baseSize * available / inlineNavWidth) + 'px');
  }

  var tallLogo = logoContainer.clientHeight > lastInlineNavLink.clientHeight + 20;
  inlineNav.classList.toggle('navigation--tight-underline', tallLogo);
};

theme.setInitialHeaderHeightProperty = function () {
  var section = document.querySelector('.section-header');
  if (section) {
    document.documentElement.style.setProperty('--theme-header-height', Math.ceil(section.clientHeight) + 'px');
  }
};

(function () {

  var discount = new URLSearchParams(location.search).get('discount');
  if (discount != null) {
    fetch(theme.routes.cartUpdate, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ discount: discount })
    });
  }
})();
